var exports = {
  "W2": "xf0b3b88a--0cd6a6--review_form",
  "h_": "xf0b3b88a--0cd6a6--description",
  "kL": "xf0b3b88a--0cd6a6--container",
};

module.exports = exports;
